export const hasRoleAccess = (userRole, allowedRoles) => {
    if (!allowedRoles || allowedRoles.length === 0) {
        return true;
    }

    if (!userRole) {
        return false;
    }

    return allowedRoles.includes(userRole);
};

export const filterRoutesByRole = (routes, userRole) => {
    if (!userRole) return [];

    return routes.filter(route => {
        // First check if the route should be shown in sidenav
        if (route.showInSidenav === false) {
            return false;
        }

        // Then check role-based access
        return hasRoleAccess(userRole, route.roles);
    });
};

export const getUserRole = (loggedInUserDetail) => {
    return loggedInUserDetail?.userRole || null;
};

export const isSystemAdmin = (userRole) => {
    return userRole === 'SYSTEM_ADMIN';
};


export const isAdmin = (userRole) => {
    return userRole === 'ADMIN';
};

export const isGuardian = (userRole) => {
    return userRole === 'GUARDIAN';
}; 
